import Temp from "@/courier/Temp";
import courierRules from "../constants/CourierRules";
export default class KerryExpress extends Temp {
  static CODE = "KRYS";
  API_URL = this._VUE.$API_URL;
  static API = {
    checkSameAddress: "/address/province/same",
    checkCodeAvailable: "/check-code-available",
  };
  static NAME_TYPE = {
    BKK_TO_BKK: 1,
    BKK_TO_UPC: 2,
    UPC23_SAME_PROVINCE: 3,
    UPC23_SAME_UPC23: 4,
    UPC23_TO_UPC: 5,
    UPC50_SAME_PROVINCE: 6,
    UPC50_SAME_UPC50: 7,
    UPC50_TO_UPC: 8,
  };

  static NAME_TYPE_3_ZONE = {
    'SAME_PROVINCE': 1,
    'WITHIN_200KM': 2,
    'MORE_THAN_1200KM': 3
  };

  static NAME_ZONE = {
    BKK: 1,
    C: 2,
    N: 3,
    NE: 4,
    E: 5,
    S: 6,
  }
  static NAME_SUB_ZONE = {
    BKK: 1,
    UPC23: 2,
    UPC50: 3,
  };

  constructor() {
    super(KerryExpress.CODE);
  }

  async getZone(item) {
    let type, from, to;
    let special_code = "";
    let cross_price = 0;
    let remote_area = 0;
    let fuel_surcharge = 0;
    if ((new Date().getTime() <= new Date('2023-09-05 00:00:00').getTime()))
      remote_area = super.checkRemoteArea(Number(item.toPostcode));

    let prefixFromPostCode = item.fromPostcode.toString().substring(0, 2);
    let prefixToPostCode = item.toPostcode.toString().substring(0, 2);

    if (
      ["94", "95", "96"].indexOf(prefixToPostCode) > -1 &&
      ["94", "95", "96"].indexOf(prefixFromPostCode) > -1
    ) {
      remote_area = 0;
    }

    from = super.checkZone(item.fromPostcode);
    to = super.checkZone(item.toPostcode);
    if (item.to.province == 'สมุทรสาคร') {
      to = KerryExpress.NAME_ZONE.BKK;
    }
    if ((item.from.source?item.from.province:item.sameData.province) == 'สมุทรสาคร') {
      from = KerryExpress.NAME_ZONE.BKK;
    }
    const sameProvince = super.checkSameProviceByName(item);
    const sameZone = to == from;
    type = await this.checkRateType(item, { from: from, to: to });
    if (new Date().getTime() <= new Date('2023-09-05 00:00:00').getTime() && item.courierPromotion) {
      if (item.specialCode) {
        special_code = item.specialCode;
      } else {
        special_code = await this.checkCodeAvailable({
          from: {
            ...item.from,
            tel: item.senderTel,
          },
          to: item.to,
          parcel: item.parcel,
          listSpecialCode: item.listSpecialCode,
        });
      }
    }

    let fuel_surcharge_data = await super.getFuelSurcharge();
    if (fuel_surcharge_data && new Date().getTime() >= new Date('2023-09-05 00:00:00').getTime()) {
      fuel_surcharge = fuel_surcharge_data['ZONE_' + type]?fuel_surcharge_data['ZONE_' + type]:fuel_surcharge;
    } else if (fuel_surcharge_data) { // TODO: remove after 1 sep 2023 if {}
      const subZone = this.checkSubZone(item);
      let fuel_prefix = "";
      switch (subZone) {
        case KerryExpress.NAME_SUB_ZONE.BKK:
          fuel_prefix = "BKKG";
          break;
        case KerryExpress.NAME_SUB_ZONE.UPC23:
          fuel_prefix = "UPC23";
          break;
        case KerryExpress.NAME_SUB_ZONE.UPC50:
          fuel_prefix = "UPC50";
          break;
      }

      if (sameProvince && from != 1 && to != 1) {
        fuel_prefix += "-INPROVINCE";
      } else if (sameZone) {
        fuel_prefix += "-INZONE";
      } else {
        fuel_prefix += "-OTHERZONE";
      }
      fuel_surcharge = fuel_surcharge_data[fuel_prefix]
        ? fuel_surcharge_data[fuel_prefix]
        : 0;
    }
    
    return {
      rate_type: type,
      rate_remote_area: remote_area,
      cross_price: cross_price,
      special_code: special_code,
      fuel_surcharge: fuel_surcharge,
    };
  }
  async checkRateType(item, zone) {
    if (new Date().getTime() >= new Date('2023-09-05 00:00:00').getTime()) {
      let zoneArea = await super.getCourierZone(KerryExpress.CODE);
      let kerryZoneProvince = zoneArea.data.coverageZone;
      let kerryZoneNumber = false;
      let fromAddress = item.sameData;
      if (item.from.source == 1) {
        fromAddress = item.from;
      }
      // เผื่อลูกค้าพิมเองไม่กด auto complete
      item.to.province = item.to.province.replace('จ.', '');
      if (!kerryZoneProvince[fromAddress.province]) {
        await super.getArea([fromAddress.district + ' ' + fromAddress.state + ' ' + fromAddress.province + ' ' +fromAddress.postcode], [KerryExpress.CODE]).then((res) => {
          if (res.original_data) {
            fromAddress.province = res.original_data.province.replacer
          }
        });
      }
      if (!kerryZoneProvince[item.to.province]) {
        await super.getArea([item.to.district + ' ' + item.to.state + ' ' + item.to.province + ' ' +item.to.postcode], [KerryExpress.CODE]).then((res) => {
          if (res.original_data) {
            item.to.province = res.original_data.province.replacer
          }
        });
      }
      // 
      if(kerryZoneProvince[fromAddress.province] && kerryZoneProvince[fromAddress.province][item.to.province]) {
        kerryZoneNumber = kerryZoneProvince[fromAddress.province][item.to.province].zone.replace('ZONE_', '');
      }
      if (kerryZoneNumber == '1') {
        return KerryExpress.NAME_TYPE_3_ZONE.SAME_PROVINCE;
      } else if (kerryZoneNumber == '2') {
        return KerryExpress.NAME_TYPE_3_ZONE.WITHIN_200KM;
      } else {
        return KerryExpress.NAME_TYPE_3_ZONE.MORE_THAN_1200KM;
      }
    }
    const subZone = this.checkSubZone(item);
    const sameProvince = await this.checkSameProvince(item);
    if (subZone === KerryExpress.NAME_SUB_ZONE.BKK) {
      if (zone.from === zone.to) return KerryExpress.NAME_TYPE.BKK_TO_BKK;
      else return KerryExpress.NAME_TYPE.BKK_TO_UPC;
    } else if (subZone === KerryExpress.NAME_SUB_ZONE.UPC23) {
      if (sameProvince) return KerryExpress.NAME_TYPE.UPC23_SAME_PROVINCE;
      else if (zone.from === zone.to)
        return KerryExpress.NAME_TYPE.UPC23_SAME_UPC23;
      else return KerryExpress.NAME_TYPE.UPC23_TO_UPC;
    } else {
      if (sameProvince) return KerryExpress.NAME_TYPE.UPC50_SAME_PROVINCE;
      else if (zone.from === zone.to)
        return KerryExpress.NAME_TYPE.UPC50_SAME_UPC50;
      else return KerryExpress.NAME_TYPE.UPC50_TO_UPC;
    }
  }

  checkSubZone(item) {
    const SUBZONE = this.listPostcodeSpecial["KRYS"]["sub-zone"];
    let find = Object.values(SUBZONE).findIndex((postcodes) => {
      return postcodes.find((postcode) => {
        return postcode == item.fromPostcode;
      });
    });
    if ((item.from.source?item.from.province:item.sameData.province) == 'สมุทรสาคร') {
      find = 0; // force bkkg
    }
    // +1 เพราะว่า index มันเป็น 0
    // 1 = BKK
    // 2 = UPC23
    // 3 ELSE => UPC50
    return find == -1 ? 3 : find + 1;
  }

  async checkSameProvince(item) {
    return (
      (!item.source && item.province.sameData == item.province.to) ||
      (item.source && item.province.from == item.province.to)
    );
  }

  async checkCodeAvailable(item) {
    if (new Date().getTime() >= new Date().getTime('2023-09-05 00:00:00')) {
      return false;
    }
    if (
      item.parcel &&
      ["ENVELOP", "SEALBAGLITE", "SEALBAGA|B", "SEALBAGC", "MINI"].includes(
        item.parcel.key_size
      )
    ) {
      const check = await this._VUE.$http.post(
        this.API_URL + KerryExpress.API.checkCodeAvailable,
        {
          courier_code: "KRYS",
          data: {
            from: item.from,
            to: item.to,
            parcel: item.parcel,
          },
          special_codes: item.listSpecialCode,
          // TODO: ส่ง special code ที่เคยได้ไปใช้บน frontend ทั้งหมดมาด้วย
        },
        {
          headers: {
            Token: localStorage.getItem("access_token"),
          },
        }
      );

      try {
        const _check = check.data;
        if (_check.status) return _check.data.special_code;
        return false;
      } catch (err) {
        console.info(err);
        return false;
      }
    }
    return false;
  }

  calculateDimensionRatio(item) {
    let dimensionRatio = 3000;
    if (item.weight > 21000) {
      dimensionRatio = 6000;
    }
    return dimensionRatio;
  }
  async checkWeight(courierRates, item, validate) {
    if (!courierRates) return {index: -1};
    let dimensionRatio = this.calculateDimensionRatio(item);
    let useWeight = item.weight;
    let dimensionWeight = super.calculateDimensionWeight(item, dimensionRatio);
    useWeight = dimensionWeight > item.weight ? dimensionWeight : item.weight;
    const maxTier = courierRates[courierRates.length - 1];
    if (useWeight > maxTier.max) {
      useWeight = item.weight;
    }
    item.index = courierRates.findIndex((rate) => {
      return useWeight >= rate.min && useWeight <= rate.max;
    });
    return super.checkRules(item, validate);
  }
  checkDimension(dimensionCourier, item, validate) {
    return super.checkCourierDimension(dimensionCourier, item, validate);
  }
  async checkRemoteAreaByCorrectorDest(addressRemote) {
    return new Promise((resolve) => {
      if (new Date().getTime() >= new Date().getTime('2023-09-05 00:00:00')) {
        resolve({isRemote: 0})
      }
      if (addressRemote.length > 10) {
        super.getArea([addressRemote], ["KRYS"]).then((res) => {
          resolve({
            isRemote: res.data.KRYS.is_remote?50:0
          });
        });
      }
    });
  }
}
